import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { CardSet, CardType } from '@models/card.model';
import { Card } from '@services/card.service';
import { Router } from '@services/route.service';
import { StatCardSet, StatService } from '@services/stat.service';
import { forkJoin, switchMap } from 'rxjs';

@Component({
  selector: 'lgb-stats-serie-list',
  imports: [
    CommonModule,
    RouterModule,
    UiModule
  ],
  templateUrl: './stats-serie-list.html',
  styleUrl: './stats-serie-list.css',
})
export class StatsSerieList {

  //services
  readonly route=inject(ActivatedRoute);
  readonly cardS=inject(Card);
  readonly statsS=inject(StatService);
  readonly router=inject(Router)

  //data
  readonly type=signal<CardType>(null);
  readonly _cardSets=signal<CardSet[]>([]);
  readonly cardSets=computed(() => this._cardSets().sort((a: CardSet, b: CardSet) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()));
  readonly stats=signal<StatCardSet[]>([]);

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);
    this.route.parent.paramMap
      .pipe(
        switchMap(params => {
          return forkJoin({
            cardSets: this.cardS.getCardSetType(params.get('type')),
            stats: this.statsS.getCardSetStats(params.get('type'))
          })
        })
      )
      .subscribe(result => {
        this._cardSets.set(result.cardSets);
        this.stats.set(result.stats);
        this.loading.set(false);
      });
  }

  getNbCard(cardSet: CardSet){
    const stat: StatCardSet=this.stats().find(s => s.cardSet==cardSet.ident);
    return ((stat)? stat.nb : 0);
  }

  getPercent(cardSet: CardSet){
    const stat: number=this.getNbCard(cardSet);
    let result: number=0;
    if(!cardSet.nbCard)
      result=100;
    else
      result=stat*100/cardSet.nbCard;
    return result;

  }
}
